import './style.scss';
import infoCircleBlue from '../../../../assets/icons/info-circle-blue-outline.svg';
import exclamationTriangleOrange from '../../../../assets/icons/exclamation-triangle-orange-outline.svg';
import exclamationHexagonRed from '../../../../assets/icons/exclamation-hexagon-red-outline.svg';
import { Severity } from '../../../models/note.model';
import DataUrlHelper from '../../../helpers/data-url.helper';
import { TranslationService } from '../../../services/translation.service';

function getIconUrl(severity: Severity | undefined): string {
  if (severity === Severity.high) {
    return DataUrlHelper.encode(exclamationHexagonRed);
  }
  if (severity === Severity.normal) {
    return DataUrlHelper.encode(exclamationTriangleOrange);
  }
  if (severity === Severity.low) {
    return DataUrlHelper.encode(infoCircleBlue);
  }
  return '';
}

function getIconAltText(severity: Severity | undefined): string {
  if (severity === Severity.high) {
    return TranslationService.get('common.icons.exclamationhexagonred');
  }
  if (severity === Severity.normal) {
    return TranslationService.get('common.icons.exclamationtriangleorange');
  }
  if (severity === Severity.low) {
    return TranslationService.get('common.icons.infocircleblue');
  }
  return '';
}

function SeverityIcon({ severity, className }: { severity: Severity | undefined; className?: string }) {
  return <img src={getIconUrl(severity)} alt={getIconAltText(severity)} className={`severity-icon ${className ?? ''}`}></img>;
}

export default SeverityIcon;
